// contact.tsx
import React, { Component } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import "../css/home.css";
import dev from "../assets/605539896_1986207411940410_162264191050048665_n.jpg";

class About extends Component {
    override render() {
        return (
            <Box sx={{
                p: 5,
                height: '75vh'
            }}>
                <Typography variant="h4" align="center" gutterBottom>
                    About The Developer
                </Typography>
                <Paper
                    elevation={0}
                    sx={{
                        p: 5,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        border: '1px solid',
                        borderColor: 'divider',
                        display: 'flex',
                        alignItems: 'center',
                        gap: {
                            md: 20,
                            xs: 5
                        },
                        flexDirection: {
                            md: 'row',
                            xs: 'column'
                        },
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}>
                        <img src={dev} style={{
                            width: "200px"
                        }} />
                        <Typography variant='h5'>Ronnel S. Mitra</Typography>
                    </Box>
                    <Typography variant='h5'>I developed this software to cater most internet cafe's needs and even usable for home usage as to ensure the application management works fine and I started creating this software which available for free and paid and I'll make it open source under AGPL License so that there are transparency to be shown to the public even students who want to study the development of my software</Typography>
                </Paper>
            </Box>
        )
    }
}

export default About;